import { Box, Button, Input, Stack,Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { searchPeppolClient } from "../api"
import { DataGrid } from "@mui/x-data-grid"
import { extractFacturX, extractFacturXFields, XmlExtractor } from "../components/factureReader"
import moment from "moment"
import { senderPepool } from "../components/factureSender"

const peppolCliCols =[
    {field:'participantID',valueGetter:(value)=>value.value.value,flex:1},
    {field:'entities',valueGetter:(value)=>value.value.map(e=>e.name).map(ee=>ee[0].name),flex:1},
    {field:''}
]

const Research=({baseValue,callBack=()=>{}})=>{
    const [clientFind,setClient]=useState([])
    const [findValue,setFindValue]=useState(baseValue||'')
    const [search,setSearch]=useState(false)
    const handleSearch=()=>{
        if(findValue && findValue!=''){
            searchPeppolClient(findValue).then(client=>setClient(client))
        }
    }
    return(
        <Box sx={{flex:1,minHeight:'100vh'}}>
            <Stack padding={2} flex={1} height={'100%'}>
                <Stack padding={2} direction={'row'}>
                    <Input placeholder="Recherche" value={findValue} onChange={(e)=>setFindValue(e.target.value)}/>
                    <Button variant='contained' onClick={handleSearch}>Recherche</Button>
                </Stack>
                <DataGrid
                     style={{ minHeight: 600 }}
                    rows={clientFind?.matches||[]}
                    getRowId={e=>e.participantID.value}
                    columns={peppolCliCols}
                    onCellDoubleClick={e=>callBack({id:e.id,entities:e.row.entities})}
                />
            </Stack>
        </Box>
    )
}

export const SenderPage=()=>{
    const [error,setError]=useState()
    const [jsonData,setJsonData]=useState() 
    const [valid,setValid]=useState(null)
    const [xmlFile,setXmlFile]=useState(null)
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        setError("");
        setJsonData(null);
    
        if (!file || !file.name.endsWith(".pdf")) {
          setError("Veuillez sélectionner un fichier PDF valide.");
          return;
        }
    
        try {
            console.log("FILE",file)
          const data = await extractFacturX(file) //extractFacturX(file);
          console.log(extractFacturXFields(data.json))
          setJsonData(extractFacturXFields(data.json))
          setValid(true)
          setXmlFile(data.xml)
          //setJsonData(data);
        } catch (err) {
          console.error(err);
          setError("Erreur lors de l'extraction du fichier XML.");
        }
      };
      const handleSend=()=>{
        console.log("XML",xmlFile)
        senderPepool({doc:xmlFile}).then(data=>console.log("SENDED"))
      }
      console.log(error,jsonData)
        const [client,setClient]=useState(null)
    return(
        <Box sx={{flex:1}}>
            {client?
            <Box>
                <Stack spacing={2}>
                <Typography>{client?.entities[0].name[0].name} - {client.id}</Typography>
                <input type="file" accept=".pdf" onChange={handleFileUpload} />
                {jsonData &&(
                    <Stack spacing={2}>
                    <Typography variant='h5'>Facture valide</Typography>
                    <Typography>{`Facture n° ${jsonData.number} du ${moment(jsonData.date,'YYYYMMDD').format("DD/MM/YYYY")} De ${jsonData.emitter} pour ${jsonData.recipient} Montant :${jsonData.totalTTC}€`} </Typography>
                    </Stack>    
                )}
                {valid===true &&(
                    <Button onClick={handleSend}>Envoyer</Button>
                )}
                </Stack>
            </Box>
            :
            <Research callBack={setClient}/>
            }
        </Box>
    )
}